import React from "react";
import { useRecover } from "../hooks/useRecover";
import { Box, FormControl, Text, FormLabel, Input, FormErrorMessage, Button, useColorModeValue } from "@chakra-ui/react";

type EmailFormProps = Pick<useRecover.type, "state" | "changeEmailInput" | "emailValidate" | "sendEmail">

export const EmailForm: React.FC<EmailFormProps> = ({ state, changeEmailInput, emailValidate, sendEmail }) => {

    const textColor = useColorModeValue("navy.700", "white");
    const brandStars = useColorModeValue("brand.500", "brand.400");

    const { loading } = state;

    return (
        <Box mt="24px">
            <FormControl isInvalid={!emailValidate()}>
                <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                >
                    E-mail<Text color={brandStars}>*</Text>
                </FormLabel>
                <Input
                    isRequired={true}
                    variant="auth"
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="email"
                    placeholder="mail@email.com.br"
                    fontWeight="500"
                    autoFocus={true}
                    size="lg"
                    onBlur={(e) => changeEmailInput(e.target.value)}
                />

                {!emailValidate() && (
                    <FormErrorMessage>E-mail precisa ser valido</FormErrorMessage>
                )}
            </FormControl>

            <Button
                fontSize="sm"
                variant="brand"
                fontWeight="500"
                w="100%"
                h="50"
                mt="24px"
                isLoading={loading}
                disabled={!emailValidate()}
                onClick={sendEmail}
            >
                SEGUIR
            </Button>

            <Button
                fontSize="sm"
                variant="outline"
                fontWeight="500"
                w="100%"
                h="50"
                mt="24px"
                isLoading={loading}
                onClick={() => window.location.href = "/auth/sign-in"}
            >
                Voltar
            </Button>
        </Box>
    );
};